// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__20gFk","unreadBadge":"styles_unreadBadge__12Cxr","modalContent":"styles_modalContent__2UGNG","modal":"styles_modal__30rXC"};